






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "./FixedPhraseTreeSelector.vue";
import { IEditFixedPhrase } from "./IEditFixedPhrase";
import { FixedPhraseTreeSelectorMixin } from "./mixins";
import { FixedPhraseKinds } from "./FixedPhraseKinds";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class CommonDepartmentFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop({ default: true })
  isPastable: boolean;

  created(): void {
    this.getFixedPhrase(FixedPhraseKinds.CommonDepartment)
    .then(d => this.rootFixedPhrase = d)
    .catch(e => {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "全" + this.$wording.common.departmentAsShort + "定型文取得失敗",
        "全" + this.$wording.common.departmentAsShort + "定型文を読み込めませんでした。",
        e);
    });
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.CommonDepartment, isForcibly), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.CommonDepartment);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.CommonDepartment, "");
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.CommonDepartment, result);
  }
}
